<template>
  <footer class="AppFooter">
    <b-container>
      <b-row>
        <b-col class="footer-logo">
          <img
            class="logo"
            src="@/assets/Building-Blocks-Logo-1.png"
            alt="The Building Blocks"
          />
        </b-col>
        <b-col class="links">          
          <div class="links__support">
            <h4 class="links__title">TECHNICAL SUPPORT</h4>
            <ul class="links__list">
              <li>
                <a
                  class="list-link"
                  href="mailto: ea@thebuildingblocks.org"
                  target="_blank"
                  rel="external noopener"
                >
                  <img
                    class="list-link__icon"
                    src="@/assets/icon-description.svg"
                  />
                  Email : ea@thebuildingblocks.org
                </a>
              </li>
              <li>
                <a class="list-link" :href="phoneNumberLink">
                  <img class="list-link__icon" src="@/assets/icon-phone.svg" />
                  Phone : 612-615-9034, Ext-5.
                  <br />
                </a>                
              </li>
            </ul>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </footer>
</template>

<script>
export default {
  name: 'AppFooter',
  computed: {
    linkData() {
      return this.$store.state.oesProperties.footer
    },
    legislationLink() {
      return (
        this.linkData &&
        this.linkData.privacy &&
        this.linkData.privacy.legislation &&
        this.linkData.privacy.legislation.link
      )
    },
    phoneNumber() {
      return (
        this.linkData &&
        this.linkData.support &&
        this.linkData.support.phone &&
        this.linkData.support.phone.number
      )
    },
    phoneHours() {
      return (
        this.linkData &&
        this.linkData.support &&
        this.linkData.support.phone &&
        this.linkData.support.phone.hours
      )
    },
    phoneNumberLink() {
      return this.phoneNumber && `tel:${this.phoneNumber.replace(/\s/g, '')}`
    },
    formLink() {
      return (
        this.linkData &&
        this.linkData.support &&
        this.linkData.support.form &&
        this.linkData.support.form.link
      )
    }
  }
}
</script>

<style scoped lang="scss">
.AppFooter {
  background-color: $color-primary;
  height: $footer-height;
  display: flex;
  align-items: center;

  .footer-logo {
    flex-grow: 0;
    padding: 0 0 0 15px;
    margin: 0;
    min-width: 67px;

    .logo {
      height: 8.5rem;
    }
  }

  .links {
    display: flex;
    justify-content: flex-end;
    color: $color-white;
    font-size: $text;
    text-decoration: none;

    > :not(:last-child) {
      margin-right: 8rem;
    }

    &__title {
      font-weight: bold;
      text-transform: uppercase;
      font-size: $text;
      line-height: $text-h4;
      padding-bottom: 1.2rem;
    }

    &__list {
      margin-bottom: 0;

      > :not(:last-child) {
        margin-bottom: 1.2rem;
      }
    }
  }

  ul {
    list-style: none;
    padding: 0;
  }

  .list-link {
    display: flex;
    align-items: center;

    &__icon {
      margin-right: 1rem;
    }

    &__additional-info {
      padding-left: 3.4rem;
      display: block;
    }
  }

  a {
    text-decoration: none;
    color: $color-white;
    font-size: $text;
    font-weight: 500;
  }

  @include tablet {
    & {
      height: auto;
    }
    .container {
      padding: 2rem;
    }
    .footer-logo {
      margin-right: 2rem;
    }
  }

  @include mobile {
    & {
      .footer-logo {
        margin-top: 2rem;
      }

      .row {
        display: block;
      }
      .links {
        display: block;
        &__privacy,
        &__support {
          margin-top: 2rem;
          margin-bottom: 2rem;
        }
      }
    }
  }
}
</style>
